import {map} from "rxjs/operator/map";
import {Observable} from "rxjs";

import {Product} from "./product";
import {SubProduct} from "./subproduct";
import {RowsIterator} from "../utils/rows.iterator";

export class Position {
    constructor(public x: number, public y: number) {
    }
}

export interface AlternativeSelectedEvent {
    productGroup: ProductGroup,
    altNumber: number,
    product: Product
}

export class ProductGroup {
    private products: Array<Product>;
    private subProducts: Array<SubProduct>;

    private metaData: any;
    private iterator: RowsIterator<Product> = null;
    private subIterator: RowsIterator<SubProduct> = null;
    private subAlternativesIterator: RowsIterator<SubProduct> = null;

    private alternativeNumber: number = 0;

    public randomNumber: number;

    constructor(metaData: {Name: string, ButtonPosX: number, ButtonPosY: number, DefaultChoice: number, DepthValue: number, SubProductDepthValue: number}, products: Array<Product>, subProducts: Array<SubProduct>, alternativeNumber?: number) {
        this.products = products;
        this.subProducts = subProducts;
        this.metaData = metaData;

        this.alternativeNumber = alternativeNumber ? alternativeNumber : 0;

        this.products.forEach((product) => {
            product.registerInGroup(this);
        });

        if(this.subProducts) {
            this.subProducts.forEach((product) => {
                product.registerInGroup(this);
            })
        }
    }

    /**
     *
     * @param group
     * @param products
     * @param subProducts
     * @returns {ProductGroup}
     */
    public static clone(group: ProductGroup, products?: Array<Product>, subProducts?: Array<SubProduct>): ProductGroup {
        return new ProductGroup(group.metaData, products, subProducts, group.alternativeNumber);
    };

    isDefault() {
        return this.metaData.DefaultChoice == 1;
    }

    setAltNumber(altNumber: number) {
        this.alternativeNumber = altNumber;
    }

    getName() {
        return this.metaData.Name;
    }

    getJsonPosition() {
        return this.metaData.jsonPosition;
    }

    replaceProduct(index: number, product: Product){
        let found = typeof this.products[index] !== "undefined" ? this.products[index] : null;
        this.products[index] = product;
        return found;
    }

    replaceSubProduct(index: number, product: SubProduct){
        let found = null;
        if(this.subProducts) {
            found = typeof this.subProducts[index] !== "undefined" ? this.subProducts[index] : null;
            this.subProducts[index] = product;
        }
        return found;
    }

    /**
     *
     * @returns {Position}
     */
    getPosition() {
        return new Position(this.metaData.ButtonPosX, this.metaData.ButtonPosY);
    }

    getSubProductName() {
        return this.metaData.SubProductName;
    }

    getDepthValue(): number {
        return this.metaData.DepthValue;
    }

    getSubProductDepthValue(): number {
        return this.metaData.SubProductDepthValue;
    }

    getSubProductDefaultChoice(): number {
        return this.metaData.SubProductDefaultChoice;
    }

    getAlternativeRenders() {
        return this.metaData.AlternativeRenders;
    }

    getAlternativesIcons() {
        return this.metaData.AlternativesIcons;
    }

    getAlternativesTabName() {
        return this.metaData.AlternativesTabName;
    }

    getAltNumber() {
        return this.alternativeNumber;
    }

    getFilterBy() {
        return this.metaData.FilterBy;
    }

    /**
     *
     * @returns {Array<Product>}
     */
    getProducts() {
        return this.products;
    }

    /**
     *
     * @returns {Array<SubProduct>}
     */
    getSubProducts() {
        return this.subProducts;
    }

    /**
     *
     * @returns {Array<SubProduct>}
     */
    getSubProductsAlternatives() {
        return this.metaData.AlternativesIcons;
    }

    getProductsIterator(columns?: number): RowsIterator<Product> {
        if (this.iterator === null) {
            columns = columns || 3;
            //
            // let actualProducts = this.products.filter((product) => {
            //     if (!product.isHidden['global'] || product.isHidden['current']) {
            //         return product;
            //     }
            // });

            this.iterator = new RowsIterator<Product>(this.products, columns);
        }
        return this.iterator;
    }

    getSubProductsIterator(columns?: number): RowsIterator<SubProduct> {
        if (this.subIterator === null) {
            columns = columns || 5;
            this.subIterator = new RowsIterator<SubProduct>(this.subProducts, columns);
        }
        return this.subIterator;
    }

    getSubProductsAlternativesIterator(columns?: number): RowsIterator<SubProduct> {
        if (this.subAlternativesIterator === null) {
            columns = columns || 5;
            this.subAlternativesIterator = new RowsIterator<SubProduct>(this.metaData.AlternativesIcons, columns);
        }
        return this.subAlternativesIterator;
    }

    /**
     *
     * @param article {string}
     * @returns {SubProduct|null}
     */
    getSubProductByArticleNumber(article: string) {
        let res = this.subProducts.filter((val) => {
            if (val.articleNumber.getValue() === article) {
                return true;
            }
            return false;
        });
        if (res && res.length > 0) {
            return res.pop();
        } else {
            return null;
        }
    }

    /**
     *
     * @param article {string}
     * @returns {Product|null}
     */
    getProductByArticleNumber(article: string) {
        let res = this.products.filter((val) => {
            if (val.articleNumber.getValue() === article) {
                return true;
            }
            return false;
        });
        if (res && res.length > 0) {
            return res.pop();
        } else {
            return null;
        }
    }

    /**
     *
     * @param id {number}
     * @returns {Product|null}
     */
    getProductById(id: number) {
        let res = this.products.filter((val) => {
            if (val.id.getValue() === id) {
                return true;
            }
            return false;
        });
        if (res && res.length > 0) {
            return res.pop();
        } else {
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/model/product.group.ts